import React from 'react';
import {
  Button,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from '@mui/material';
import { Page } from '@/declarations/models/Page';
import { MaterialSymbol } from '@/components/MaterialSymbol';
import Styles from '@/assets/js/Styles';

type Props = {
  pages: Page[];
  pagesCount: number;
  sitesCount: number;
  tComp: (key: string) => string;
  getSanitizedUrl: (url: string) => string | null;
};

export function AnalysisTable({ pages, pagesCount, sitesCount, tComp, getSanitizedUrl }: Props) {
  return (
    <>
      <Typography>
        Totalt {pagesCount} pages fordelt på {sitesCount} sites
      </Typography>
      <TableContainer component={Paper}>
        <Table className='compact-table' stickyHeader sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Page ID</TableCell>
              <TableCell>Page name</TableCell>
              <TableCell>Page locale</TableCell>
              <TableCell>Page status</TableCell>
              <TableCell>Site ID</TableCell>
              <TableCell>Site NAME</TableCell>
              <TableCell>Portal URL</TableCell>
              <TableCell>Editor URL</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pages.length > 0 ? (
              pages.map((page, idx) => (
                // eslint-disable-next-line react/no-array-index-key -- id is unique and safe here
                <TableRow key={`${idx}-${page.id}`}>
                  <TableCell>{idx + 1}</TableCell>
                  <TableCell>{page.id}</TableCell>
                  <TableCell>{page.title}</TableCell>
                  <TableCell>{page.locale}</TableCell>
                  <TableCell>{page.status}</TableCell>
                  <TableCell>{page.site_id}</TableCell>
                  <TableCell>{page.site_name}</TableCell>
                  <TableCell>
                    {page.url && page.status !== 'draft'
                      ? (() => {
                          const sanitized = getSanitizedUrl(page.url);
                          return sanitized ? (
                            <a
                              style={{ maxWidth: '200px', lineBreak: 'anywhere' }}
                              href={sanitized}
                              target='portal'
                              rel='noopener noreferrer'>
                              {sanitized}
                            </a>
                          ) : (
                            'N/A'
                          );
                        })()
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    <a
                      href={`/editor/${page.id}`}
                      target='admin-editor'
                      rel='noopener noreferrer'
                      style={{
                        textDecoration: 'none',
                        display: 'inline-block',
                        width: '100%',
                      }}>
                      <Button
                        variant='contained'
                        sx={{
                          boxShadow: undefined,
                          px: 3,
                          whiteSpace: 'nowrap',
                          border: `1px solid ${Styles.Colors.MEDIUM_LIGHT_GREY}`,
                          minWidth: 'fit-content',
                        }}
                        startIcon={<MaterialSymbol name='edit' fill />}>
                        {tComp(`PageTreeContent.edit`)}
                      </Button>
                    </a>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={9} align='center'>
                  No pages found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
